<template>
  <div class="mx-10 ma-5">
    <v-card flat class="pa-5">
      <div>
        <PageTitleWithSearch
          :title="'Expenses'"
          :btnName="'Add New Expense'"
          :btnColor="'#00B3FF'"
          :btnRoute="'/expenses/create'"
          :btnPermission="'expenses.create'"
          :btnEnable="true"
          :loading="loading"
          :search="search"
          @searchText="searchChange($event)"
        />

        <DataTableWithPagination
          :headers="tableHeaders"
          :items="expenses"
          :loading="loading"
          :page="page"
          :total="total"
          @pageChange="page = $event"
        >
          <template #row="{ item, index }">
            <tr
              :class="[
                { 'first-row': index === 0 },
                index % 2 === 0 ? 'dark-row' : 'light-row',
                'custom-row',
              ]"
            >
              <td>{{ item.payee }}</td>
              <td>{{ item.description }}</td>
              <td>{{ item.dr_account.title }}</td>
              <td>{{ item.cr_account.title }}</td>
              <td>{{ item.amount }}</td>
              <td>{{ item.payment_type }}</td>
              <td>{{ formatDate(item.date_of_expense, dateFormat) }}</td>
              <td class="text-left">
                <v-btn
                  v-if="item.is_post === 0 && hasPermission('expenses.post')"
                  color="primary"
                  x-small
                  @click="postExpense(item.id)"
                  class="ma-1"
                >
                  <v-icon left small>mdi-check</v-icon>
                  Post
                </v-btn>
                <v-btn v-else color="grey" x-small disabled class="ma-1">
                  <v-icon left small>mdi-check</v-icon>
                  Posted
                </v-btn>
              </td>
            </tr>
          </template>
        </DataTableWithPagination>
        <!-- </template>
        <template v-else>
          <v-alert type="info" class="mt-5" outlined>
            No expenses found for the applied filters.
          </v-alert>
        </template> -->
      </div>
    </v-card>
    <ConfirmModal
      :text="'Do you want to drop this Expense?'"
      :title="'Drop Expense'"
      :color="'red'"
      :confirmOpen="confirmOpen"
      @cancelConfirm="cancelConfirm()"
      @confirm="confirm()"
    ></ConfirmModal>
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'success'"
      @closeSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import { useDateFormatter } from "@/composables/useDateFormatter.js";
import DataTableWithPagination from "@/components/shared/DataTableWithPagination.vue";
import { ExpenseService } from "@/services/expense-service.js";
import PageTitleWithSearch from "@/components/shared/PageTitleWithSearch";
import Snackbars from "@/components/shared/Snackbars";
import ConfirmModal from "@/components/shared/ConfirmModal";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
const { mapGetters: mapSettingsGetters } = createNamespacedHelpers("settings");

export default {
  setup() {
    const { formatDate } = useDateFormatter();
    return { formatDate };
  },
  components: {
    PageTitleWithSearch,
    Snackbars,
    ConfirmModal,
    DataTableWithPagination,
  },
  data() {
    return {
      dropId: null,
      confirmOpen: false,
      loading: true,
      expenses: [],
      snackbar: false,
      successMsg: "",
      search: "",
      page: 1,
      total: 0,
      headers: [
        { text: "Payee", value: "payee" },
        { text: "Description", value: "description" },
        { text: "Debit GL account", value: "dr_id" },
        { text: "Credit GL account", value: "cr_id" },
        { text: "Amount", value: "amount", isCurrency: true },
        { text: "Payment Type", value: "payment_type" },
        { text: "Date Of Expense", value: "date_of_expense" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    ...mapGetters({
      hasPermission: "hasPermission",
    }),
    ...mapSettingsGetters({
      dateFormat: "dateFormat",
      currencyCode: "currencyCode",
    }),
    tableHeaders() {
      return this.headers.map((h) => {
        if (h.isCurrency) {
          return {
            ...h,
            text: `${h.text} (${this.currencyCode})`, // Add currency code automatically
          };
        }
        return h;
      });
    },
  },
  created() {
    this.fetchExpenses();
  },
  watch: {
    search() {
      this.page = 1;
      this.fetchExpenses();
    },
    page() {
      this.fetchExpenses();
    },
  },
  methods: {
    async fetchExpenses() {
      this.loading = true;
      try {
        const response = await ExpenseService.getExpenses(
          this.search,
          this.page
        );
        this.expenses = response.data?.data || [];
        this.total = response.data?.meta?.last_page || 0;
      } catch (error) {
        this.expenses = [];
        this.total = 0;
        console.error("Error fetching expenses:", error);
      } finally {
        this.loading = false;
      }
    },

    async postExpense(id) {
      try {
        await ExpenseService.postExpense(id); // Adjust this to your actual API method
        this.successMsg = "Expense posted successfully.";
        this.snackbar = true;
        this.fetchExpenses();
      } catch (error) {
        console.error("Error posting expense:", error);
        this.successMsg = "Failed to post expense.";
        this.snackbar = true;
      }
    },

    async deleteExpense(id) {
      try {
        await ExpenseService.deleteExpense(id);
        this.successMsg = "Expense deleted successfully.";
        this.snackbar = true;
        this.fetchExpenses();
      } catch (error) {
        console.error("Error deleting expense:", error);
      }
    },

    dropMemberConfirm(id) {
      this.dropId = id;
      this.confirmOpen = true;
    },

    cancelConfirm() {
      this.confirmOpen = false;
    },

    confirm() {
      this.confirmOpen = false;
      this.deleteExpenseType(this.dropId);
    },

    closeSnackbar() {
      this.snackbar = false;
    },
    searchChange(value) {
      this.search = value;
    },
  },
};
</script>
